import { MantineThemeOverride } from '@mantine/core';

export type BurgerTheme = NonNullable<MantineThemeOverride['components']>['Burger'];

export const Burger: BurgerTheme = {
  // todo: define
};
